import type { ProjectDto } from '@nsb/core';
import { useParams } from 'react-router';
import { useApi } from '../../api.ts';

export function useProjectId(): string {
  return useParams<{ projectId: string }>().projectId!;
}

export function useProject(projectId: string) {
  return useApi<ProjectDto>(['project', projectId], `/projects/${projectId}`);
}

/** The project's files (Files, and the iterations that pick from them). */
export const assetsKey = (projectId: string) => ['project', projectId, 'assets'];
